<template>
    <div v-if="!loading">
        <template v-for="(zona, index) in zonas">
            <div class="row mb-4" :key="index">
                <div class="col-8 col-md-10">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <strong>{{ zona.nombre }}</strong>
                        </div>
                        <div class="col-12 col-md-8">
                            <multiselect
                                v-model="zona.vouchers"
                                placeholder="Descuentos"
                                label="name"
                                track-by="id"
                                :options="vouchers"
                                :multiple="true"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-4 col-md-2">
                    <Button @click.prevent="updateRegions([zona])">Guardar</Button>
                </div>
            </div>
        </template>
    </div>
    <div v-else>
        <div class="card-body">
            <LoaderComponent/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'VoucherRegionTableComponent',
        props: ['event_id', 'session_id', 'vouchers'],
        data() {
            return {
                expand: [],
                voucher_regions: [],
                loading: false,
                zonas: [],
            }
        },
        created() {
            this.getZonas()
        },
        methods: {
            getZonas() {
                this.loading = true
                const params = {
                    filters: { tipo: 'normal', with: 'vouchers' },
                    sesion_id: this.session_id,
                    evento_id: this.event_id,
                    tipo: 'normal',
                }
                this.$store
                    .dispatch(
                        this.config.getVuexAlias('back.events.sesiones.zonas'),
                        params
                    )
                    .then(res => {
                        this.zonas = res.data.zonas
                    })
                    .finally(() => (this.loading = false))
            },
            updateRegions(regions) {
                this.loading = true
                const params = {
                    regions,
                    session_id: this.session_id,
                    event_id: this.event_id,
                }
                this.$store
                    .dispatch(
                        this.config.getVuexAlias(
                            'back.events.voucher_regions.update'
                        ),
                        params
                    )
                    .finally(() => (this.loading = false))
            },
            updateAllRegions() {
                this.loading = true
                const params = {
                    regions: this.zonas,
                    session_id: this.session_id,
                    event_id: this.event_id,
                }
                this.$store
                    .dispatch(
                        this.config.getVuexAlias(
                            'back.events.voucher_regions.update'
                        ),
                        params
                    )
                    .finally(() => (this.loading = false))
            },
        }
    }
</script>
